module.exports = __webpack_public_path__ + "static/media/on.cd3ea36d.png";